module.exports = "https://coursera_assets.s3.amazonaws.com/images/2663d49cb612d5435a07dd8b892db285.png";